import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'faire_direct-faire_direct_landing_page_load-view';

/**
 * Track this event when the page component is loaded for k seconds.
 */
export function trackFaireDirectFaireDirectLandingPageLoadView(
  brandSubdomain: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { brandSubdomain },
  });
}
